import { render, staticRenderFns } from "./checkRisk.vue?vue&type=template&id=c7f3b120&scoped=true&"
import script from "./checkRisk.vue?vue&type=script&lang=js&"
export * from "./checkRisk.vue?vue&type=script&lang=js&"
import style0 from "./checkRisk.vue?vue&type=style&index=0&id=c7f3b120&scoped=true&lang=css&"
import style1 from "./checkRisk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f3b120",
  null
  
)

export default component.exports